<template>
    <div class="page-container">
        <div class="section">
            <div class="section-title">发票总金额 <span>(已经开具发票的酒将不可退货)</span></div>
            <div class="amount-grp">
                <div class="amount-input-grp">
                    <span>¥</span>
                    <input type="number" placeholder="未开具发票金额54647.988"/>
                </div>
                <div class="btn-all">全部</div>
            </div>
        </div>
        <div class="section">
            <div class="section-title">发票信息 <span>(请填写转账时相关的账户信息)</span></div>
            <div class="invoice-info-block">
                <div class="info-row">
                    <div class="row-left">发票类型</div>
                    <div class="row-right">增值税电子普通发票</div>
                </div>
                <div class="info-row">
                    <div class="row-left">抬头类型</div>
                    <div class="row-right">
                        <van-radio-group v-model="invoiceType" direction="horizontal">
                            <van-radio name="0">个人</van-radio>
                            <van-radio name="1">企业</van-radio>
                        </van-radio-group>
                    </div>
                </div>
                <div class="info-row">
                    <div class="row-left">发票抬头</div>
                    <div class="row-right invoice-name-row">
                        <input type="text" class="invoice-name" placeholder="填写需要开具发票的姓名" />
                        <div class="btn-used-invoice">常用发票</div>
                    </div>
                </div>
                <div class="info-row" v-show="invoiceType == 1">
                    <div class="row-left">税号</div>
                    <div class="row-right">
                        <input type="text" class="invoice-email" placeholder="纳税人识别号"/>
                    </div>
                </div>
                <div class="info-row">
                    <div class="row-left">收票人邮箱</div>
                    <div class="row-right">
                        <input type="text" class="invoice-email" placeholder="填写收票人邮箱"/>
                    </div>
                </div>
                <div class="info-row">
                    <div class="row-left">设置为常用信息</div>
                    <div class="row-right">
                        <van-switch v-model="defaultFlag" size="22px" />
                    </div>
                </div>
            </div>
            <div class="invoice-info-block">
                <div class="info-row">
                    <div class="row-left">发票内容</div>
                    <div class="row-right">
                        <van-radio-group v-model="invoiceContent" direction="horizontal">
                            <van-radio name="0">类别</van-radio>
                            <van-radio name="1">明细</van-radio>
                        </van-radio-group>
                    </div>
                </div>
                <div class="info-row">
                    <div class="row-left">备注</div>
                    <div class="row-right">
                        <input type="text" class="invoice-email" placeholder="请输入备注"/>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="section">
            <div class="section-title">商品信息 <span>(请填写本次申请发票的商品数量)</span></div>
            <div class="goods-list">
                <div class="goods-item">
                    <div class="goods-name">御粮 春生</div>
                    <div class="item-input-grp">
                        <input type="number" placeholder="请输入单价" />
                        <input type="number" placeholder="请输入数量" />
                        <select>
                            <option value="0">瓶</option>
                            <option value="1">箱</option>
                        </select>
                    </div>
                </div>
                <div class="goods-item">
                    <div class="goods-name">御粮 夏长</div>
                    <div class="item-input-grp">
                        <input type="number" placeholder="请输入单价" />
                        <input type="number" placeholder="请输入数量" />
                        <select>
                            <option value="0">瓶</option>
                            <option value="1">箱</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="bottom-notice">已开票的商品不支持退货</div>
        </div>
        <div class="btn-confirm" @click="confirmInvoice">确认申请开票</div>
    </div>
</template>
<script>
import { RadioGroup,Radio,Switch,Dialog,Toast } from 'vant'
export default {
    data(){
        return {
            invoiceType:'0',
            defaultFlag:false,
            invoiceContent:'0',
        }
    },
    components:{
        [RadioGroup.name]:RadioGroup,
        [Radio.name]:Radio,
        [Switch.name]:Switch,
        [Dialog.name]:Dialog,
        [Toast.name]:Toast
    },
    methods:{
        confirmInvoice(){
            Dialog.confirm({
                title: '提示',
                message: '申请开票后的商品将不允许退货，您确认申请开票吗？<br/><br/><span style="font-size: 10px;color:#3088F5;">(提交申请后财务将进行审批，您可在开票记录中看出开票结果)</span>',
                confirmButtonColor:'#007AFF'
            })
            .then(() => {
                // on confirm

                Toast('发票申请成功');
            })
            .catch(() => {
                // on cancel
            });
        }
    }
}
</script>
<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
::v-deep .van-radio--horizontal:last-child{
    margin-right: 0;
}
.page-container{
    min-height:calc(100vh - 46px);
    background:#fafafa;
    box-sizing: border-box;
    padding:10px;
    .section{
        margin-bottom: 10px;
        .section-title{
            margin-bottom: 10px;
            color:#333;
            font-size: 16px;
            line-height: 22px;
            &>span{
                font-size: 12px;
                color:#999;
            }
        }
        .amount-grp{
            height:44px;
            line-height: 44px;
            background:#fff;
            box-sizing: border-box;
            padding:0 15px;
            @include flex-between;
            font-size: 14px;
            .amount-input-grp{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                &>span{
                    font-size: 18px;
                    color:#333;
                    margin-right: 3px;
                }
                &>input{
                    width:190px;
                    line-height: 44px;
                    height:44px;
                    border:none;
                }
            }
            .btn-all{
                color:#3088F5;
            }
        }
        .goods-list{
            background: #fff;
            padding:15px;
            @media screen and (max-width: 750px){
                border-radius: 4px;
            }
            .goods-item{
                margin-bottom: 20px;
                .goods-name{
                    margin-bottom: 10px;
                    color:#000;
                    line-height: 22px;
                    font-size: 16px;
                }
                .item-input-grp{
                    &>input,&>select{
                        width:100px;
                        height:34px;
                        line-height: 34px;
                        background:#f5f5f5;
                        border:none;
                        font-size: 14px;
                        margin-right: 15px;
                        box-sizing: border-box;
                        padding:0 8px;
                        @media screen and (max-width: 750px){
                            border-radius: 2px;
                        }
                    }
                    &>select{
                        width:50px;
                    }
                }
            }
        }
        .bottom-notice{
            margin-top: 10px;
            font-size: 12px;
            color:#3088f5;
            line-height: 17px;
            text-align: right;
        }
        .invoice-info-block{
            background:#fff;
            margin-bottom: 10px;
            @media screen and (max-width:750px){
               border-radius: 4px; 
            }
            padding:0 15px;
            .info-row{
                height:36px;
                @include flex-between;
                font-size: 14px;
                color:#333;
                .row-right{
                    .invoice-email{
                        width:186px;
                        border:none;
                        text-align: right;
                    }
                    &.invoice-name-row{
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        .invoice-name{
                            border:none;
                            width: 152px;
                        }
                        .btn-used-invoice{
                            color:#3088F5;
                            margin-left: 10px;
                        }
                    }
                }
            }
        }
    }
    .btn-confirm{
        width: 180px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
        font-size: 14px;
        color:#fff;
        margin: 25px auto;
        @media screen and (max-width: 750px){
            border-radius: 26px;
        }
    }
}
</style>